export interface BunddleTextType {
    parentVariantId?: string;
    subs?: BundleItemType[];
    type?: 'bundle' | 'customize';
    link_buy?: string;
    power?: string;
    desc?: string;
    quantity?: number;
    tip?: string;
}

export interface BundleItemType extends BunddleTextType {
    variantId?: string;
    productId?: string;
    sku?: string;
    inventoryQuantity?: number;
    inventoryPolicy?: string;
    price?: number;
    compareAtPrice?: number;
    img?: string;
    variantImg?: string;
    productTitle?: string;
    skuTitle?: string;
    handle?: string;
}

export interface BundleIdsType {
    [key: string]: BundleItemType[];
}

export const bundleIds: BundleIdsType = {
    us: [
        {
            productId: '15386067730505',
            variantId: '54691871227977',
            subs: [
                {
                    parentVariantId: '54691871227977',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54691871227977',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
                {
                    parentVariantId: '54691871227977',
                    productId: '7289250054217',
                    variantId: '41631793250377',
                },
            ],
        },
        {
            productId: '15386067730505',
            variantId: '54691871260745',
            subs: [
                {
                    parentVariantId: '54691871260745',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
                {
                    parentVariantId: '54691871260745',
                    productId: '7289250054217',
                    variantId: '41631793250377',
                },
                {
                    parentVariantId: '54691871260745',
                    productId: '7414779576393',
                    variantId: '42093673021513',
                },
            ],
        },
        {
            productId: '42093673021513',
            variantId: '54691871293513',
            subs: [
                {
                    parentVariantId: '54691871293513',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
                {
                    parentVariantId: '54691871293513',
                    productId: '7289250054217',
                    variantId: '41631793250377',
                },
                {
                    parentVariantId: '54691871293513',
                    productId: '7414779576393',
                    variantId: '42093673021513',
                },
            ],
        },
        {
            productId: '15386067730505',
            variantId: '54692156801097',
            subs: [
                {
                    parentVariantId: '54692156801097',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
                {
                    parentVariantId: '54692156801097',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54692156801097',
                    productId: '7414779576393',
                    variantId: '42093673021513',
                },
            ],
        },
        {
            productId: '15386067730505',
            variantId: '54692156833865',
            subs: [
                {
                    parentVariantId: '54692156833865',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54692156833865',
                    productId: '7289250054217',
                    variantId: '41631793250377',
                },
                {
                    parentVariantId: '54692156833865',
                    productId: '7414779576393',
                    variantId: '42093673021513',
                },
            ],
        },
        {
            productId: '15386067730505',
            variantId: '54692156866633',
            subs: [
                {
                    parentVariantId: '54692156866633',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54692156866633',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
                {
                    parentVariantId: '54692156866633',
                    productId: '7289250054217',
                    variantId: '41631793250377',
                },
            ],
        },
    ],
    ca: [
        {
            productId: '15164532916595',
            variantId: '62060639584627',
            subs: [
                {
                    parentVariantId: '62060639584627',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62060639584627',
                    productId: '8066687074458',
                    variantId: '52162328330611',
                },
                {
                    parentVariantId: '62060639584627',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
            ],
        },
        {
            productId: '15164532916595',
            variantId: '62060639650163',
            subs: [
                {
                    parentVariantId: '62060639650163',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
                {
                    parentVariantId: '62060639650163',
                    productId: '8332890308762',
                    variantId: '45161343713434',
                },
                {
                    parentVariantId: '62060639650163',
                    productId: '8066687074458',
                    variantId: '52162328330611',
                },
            ],
        },
        {
            productId: '15164532916595',
            variantId: '62060639617395',
            subs: [
                {
                    parentVariantId: '62060639617395',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
                {
                    parentVariantId: '62060639617395',
                    productId: '8332890308762',
                    variantId: '45161343713434',
                },
                {
                    parentVariantId: '62060639617395',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
            ],
        },
        {
            productId: '15164532916595',
            variantId: '62060639715699',
            subs: [
                {
                    parentVariantId: '62060639715699',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
                {
                    parentVariantId: '62060639715699',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62060639715699',
                    productId: '8066687074458',
                    variantId: '52162328330611',
                },
            ],
        },
        {
            productId: '15164532916595',
            variantId: '62060639682931',
            subs: [
                {
                    parentVariantId: '62060639682931',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62060639682931',
                    productId: '8332890308762',
                    variantId: '45161343713434',
                },
                {
                    parentVariantId: '62060639682931',
                    productId: '15052470157683',
                    variantId: '52405151662451',
                },
            ],
        },
        {
            productId: '15164532916595',
            variantId: '62060639748467',
            subs: [
                {
                    parentVariantId: '62060639748467',
                    productId: '8066687074458',
                    variantId: '52162328330611',
                },
                {
                    parentVariantId: '62060639748467',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62060639748467',
                    productId: '8332890308762',
                    variantId: '45161343713434',
                },
            ],
        },
    ],
};
